import React from "react";
import styled from "styled-components";
import { PageHero, StripeCheckout } from "../components";
// extra imports
import { useCartContext } from "../context/cart_context";
import { Link } from "react-router-dom";
import { useUserContext } from "../context/user_context";
import { GiH2O } from "react-icons/gi";

const CheckoutPage = () => {
  const { currentUser } = useUserContext();
  return (
    <Wrapper className="page-100">
      <section>
        {currentUser && currentUser.name && <h2>Hi, {currentUser.name}</h2>}
        <hr />
        <h4 className="my-3">
          currently, checkout feature is blocked by server. Sorry for your
          inconvinience...
        </h4>
        <Link to="/" className="btn">
          back home
        </Link>
      </section>
    </Wrapper>
  );
};

const Wrapper = styled.main`
  background: var(--clr-primary-10);
  display: flex;
  justify-content: center;
  align-items: center;
  text-align: center;
  h1 {
    font-size: 10rem;
  }
  h3 {
    text-transform: none;
    margin-bottom: 2rem;
  }
`;
export default CheckoutPage;
